export function propToCssModule(prop) {
  if (!prop) return null;

  const propAsString = prop.toString();
  const capitalisedFirstChar = propAsString.charAt(0).toUpperCase();
  const remainingChars = propAsString.slice(1);

  return capitalisedFirstChar + remainingChars;
}
